import { SlatePlugin } from '../../../../../slatePlugins/slatePlugins.types';
import { SAMPLE_SPECIAL_OBJECT_VOID } from './types';
import dynamic from 'next/dynamic';

import { getRenderElement } from '../../../../../slatePlugins/common/utils/getRenderElement';
import { setDefaults } from '../../../../../slatePlugins/common/utils/setDefaults';

const UserSpecialObjectElement = dynamic(() =>
  import('./components/UserSpecialObjectElement').then((mod) => mod.UserSpecialObjectElement)
);

export const renderElementSpecialObjectVoid = (options?: any) => {
  const { specialObjectVoid } = setDefaults(options, {
    specialObjectVoid: {
      type: SAMPLE_SPECIAL_OBJECT_VOID,
      component: UserSpecialObjectElement,
    },
  });

  return getRenderElement(specialObjectVoid);
};

export const SampleSpecialObjectReadOnlyPlugin = (options?: any): SlatePlugin => ({
  renderElement: renderElementSpecialObjectVoid(options),
  voidTypes: [SAMPLE_SPECIAL_OBJECT_VOID],
});
